var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.meta.hideNavigation)?_c('Nav'):_vm._e(),_vm._v(" "),(_vm.$route.meta.hideNavigation)?_c('NoNav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }